//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const values = ref([20, 40])

    return { values }
  },
}
